import { formatTicketDate } from "./ticketConstants";

export default function MessageItem({ message, isOwn }) {
  return (
    <div className={`message-item ${isOwn ? "own" : "reciever"}`}>
      <div className="message-sender">{message.senderId?.name || "system"}</div>
      <div className="message-text">{message?.message}</div>
      <div className="message-type">
        <div className="message-type-p">
          {message.type === "comment" ? message?.type : message?.status}
        </div>
        <div className="message-type-p">{formatTicketDate(message.createdAt)}</div>
      </div>
    </div>
  );
}
